import * as types from "../../constants";
import {
    fetchRecordsPatientAllSurveysService, fetchPatientSubmissionsSlimService, fetchRecordsPatientFromSurveyService, postRecordPatientService, updateRecordPatientService, fetchRecordsSurveysService, getSubmissionPatientService, deleteSubmission, stopTreatmentPatientService, addAddendumToSubmissionService
} from "../../services";

// SHER-483: load the SLIM submissions metadata for the clinical-history TABLE (id / Form /
// Created by / Date) — no surveyRecords, so opening a patient stops assembling the whole
// history. The detail view (action=show) and the prescriptions/treatment merge (action=fill)
// still load the FULL submissions on demand. The flat slim list is grouped into the same
// `surveys[]` shape the reducer/store already use, with a __slim flag so the full-load effect
// can detect it. The full per-submission content is fetched on click (getSubmissionPatientService).
export function fetchSlimSubmissionsPatientAction(uuidInvestigation, uuidPatient, opts = {}) {
    return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });

      return fetchPatientSubmissionsSlimService(uuidInvestigation, uuidPatient, opts)
        .then((response) => {
          const bySurvey = {};
          (response.submissions || []).forEach((s) => {
            if (!bySurvey[s.uuidSurvey]) {
              bySurvey[s.uuidSurvey] = { uuid: s.uuidSurvey, surveyName: s.surveyName, type: s.type, submissions: [] };
            }
            bySurvey[s.uuidSurvey].submissions.push({
              id: s.id,
              uuidSurvey: s.uuidSurvey,
              createdAt: s.createdAt,
              updatedAt: s.updatedAt,
              researcher: s.researcher,
              uuidUnit: s.uuidUnit ?? null,
              // SHER-1055: the stopped state of a treatment submission rides on the slim
              // row, so the table shows it (and withholds the stop action) after a reload.
              treatmentStoppedAt: s.treatmentStoppedAt ?? null,
              surveyRecords: [],
              __slim: true,
            });
          });
          dispatch({
            type: types.FETCH_SUBMISSIONS_PATIENT_SUCCESS,
            surveys: Object.values(bySurvey),
            meta: { uuidPatient },
          });
        })
        .catch((error) => {
          if (!error.response) {
            dispatch({ type: types.FETCH_SUBMISSIONS_PATIENT_SUCCESS, surveys: [], meta: { uuidPatient } });
          } else {
            dispatch({ type: types.FETCH_SUBMISSIONS_PATIENT_ERROR });
            throw error;
          }
        });
    };
}


export function removeSubmissionPatient(uuidPatient, idSubmission, uuidSurvey) {
    
    return async (dispatch) => {
      dispatch({ 
            type: types.REMOVE_SUBMISSIONS_PATIENT,
            meta : {
                uuidPatient:uuidPatient,
                idSubmission,
                uuidSurvey
            }
      });
    };
}

export function fetchSingleSubmissionsPatientInvestigationAction(uuidInvestigation, idSumission, uuidPatient) {
    return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });
  
      return getSubmissionPatientService(uuidInvestigation, idSumission)
        .then((response) => {
          dispatch({
            type: types.FETCH_SINGLE_SUBMISSIONS_PATIENT_SUCCESS,
            submission: response.submission,
            meta:{uuidPatient}
          });
        })
        .catch((error) => {
          if(!error.response){
            dispatch({
              type: types.FETCH_SINGLE_SUBMISSIONS_PATIENT_SUCCESS,
              submission: response.submission,
              meta:{uuidPatient}
            });
          }
          else{
              dispatch({ type: types.FETCH_SUBMISSIONS_PATIENT_ERROR });
              throw error;
          }
          
        });
    };
}

export function fetchSubmissionsPatientInvestigationAction(uuidInvestigation, uuidPatient) {
    return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });
  
      return fetchRecordsPatientAllSurveysService(uuidInvestigation, uuidPatient)
        .then((response) => {
          dispatch({
            type: types.FETCH_SUBMISSIONS_PATIENT_SUCCESS,
            surveys: response.surveys,
            meta:{uuidPatient}
          });
        })
        .catch((error) => {
          if(!error.response){
            dispatch({
              type: types.FETCH_SUBMISSIONS_PATIENT_SUCCESS,
              surveys: [],
              meta:{uuidPatient}
            });
          }
          else{
              dispatch({ type: types.FETCH_SUBMISSIONS_PATIENT_ERROR });
              throw error;
          }
          
        });
    };
}

// SHER-495: load ONLY one survey's submissions for a patient (MATRIX FORM, treatment chart),
// merging into the store so the slim list rows of the other surveys survive. Replaces the
// all-surveys bulk fetch for single-survey consumers. Mirrors the offline-tolerant error
// handling of fetchSubmissionsPatientInvestigationAction (no error dispatch on network drop).
export function fetchSurveySubmissionsPatientAction(uuidInvestigation, uuidPatient, uuidSurvey) {
    return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });

      return fetchRecordsPatientFromSurveyService(uuidInvestigation, uuidPatient, uuidSurvey)
        .then((response) => {
          dispatch({
            type: types.FETCH_SUBMISSIONS_PATIENT_SURVEY_SUCCESS,
            surveys: response.surveys,
            meta:{uuidPatient}
          });
        })
        .catch((error) => {
          if(!error.response){
            dispatch({
              type: types.FETCH_SUBMISSIONS_PATIENT_SURVEY_SUCCESS,
              surveys: [],
              meta:{uuidPatient}
            });
          }
          else{
              dispatch({ type: types.FETCH_SUBMISSIONS_PATIENT_ERROR });
              throw error;
          }
        });
    };
}

// export function getSubmissionPatientAction(uuidInvestigation, idSubmission) {
//     return async (dispatch) => {
//       dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });
  
//       return fetchRecordsPatientAllSurveysService(uuidInvestigation, idSubmission)
//         .then((response) => {
//           dispatch({
//             type: types.FETCH_SINGLE_SUBMISSIONS_PATIENT_SUCCESS,
//             surveys: response.surveys,
//             meta:{idSubmission}
//           });
//         })
//         .catch((error) => {
//           if(!error.response){
//             dispatch({
//               type: types.FETCH_SUBMISSIONS_PATIENT_SUCCESS,
//               surveys: [],
//               meta:{uuidPatient}
//             });
//           }
//           else{
//               dispatch({ type: types.FETCH_SUBMISSIONS_PATIENT_ERROR });
//               throw error;
//           }
          
//         });
//     };
// }


export function postSubmissionPatientAction(postObj, uuidInvestigation, uuidPatient, surveyUUID, surveyName, surveyType, oldIdSubmission) {
    return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });
  
      return postRecordPatientService(postObj, uuidInvestigation, uuidPatient, surveyUUID)
        .then((response) => {
          dispatch({
            type: types.SAVE_SUBMISSIONS_PATIENT_SUCCESS,
            submission: response.submission,
            meta:{uuidPatient, surveyUUID, surveyName, surveyType, oldIdSubmission}
          });
        })
        .catch(function (error) {
          if(!error.status && !error.response){
                const offlinePost = postObj;
                //offlinePost.surveyRecords = postObj.submission[0].answers;
                dispatch({
                  type: types.SAVE_SUBMISSIONS_PATIENT_OFFLINE,
                  submission: offlinePost,
                  meta:{uuidPatient, surveyUUID, surveyName, surveyType}
                });
          }
          else{
            dispatch({ 
                type: types.SAVE_SUBMISSIONS_PATIENT_ERROR,
                error: error.errorCode
              });
            throw error;  
          }
          
        });
    };
}

export function updateSubmissionPatientAction(postObj, uuidInvestigation, uuidPatient, surveyUUID, surveyName, idSubmission) {
    return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });
  
      return updateRecordPatientService(postObj, uuidInvestigation, uuidPatient, surveyUUID, idSubmission)
        .then((response) => {
          dispatch({
            type: types.UPDATE_SUBMISSIONS_PATIENT_SUCCESS,
            submission: response.submission,
            meta:{uuidPatient, surveyUUID, surveyName, idSubmission}
          });
        })
        .catch((error) => {
          
          if(!error.status && !error.response){
            const offlinePost = postObj;
            //offlinePost.surveyRecords = postObj.submission[0].answers;
            dispatch({
              type: types.UPDATE_SUBMISSIONS_PATIENT_OFFLINE,
              submission: offlinePost,
              meta:{uuidPatient, surveyUUID, surveyName, idSubmission}
                  });
            }
            else{
              // Extract error details from response
              const errorCode = error.response?.data?.errorCode || error.errorCode;
              const errorMessage = error.response?.data?.errorMessage || error.message;
              
              dispatch({ 
                type: types.SAVE_SUBMISSIONS_PATIENT_ERROR,
                error: errorCode,
                errorMessage: errorMessage
              });
              
              // Enhance error object with extracted data for UI handling
              const enhancedError = new Error(errorMessage || 'Failed to update submission');
              enhancedError.errorCode = errorCode;
              enhancedError.originalError = error;
              throw enhancedError;
            }
         
        });
    };
}


/**
 * SHER-223 Phase 2: post a free-text correction note (addendum) attached to
 * an existing clinical submission. The original submission is not modified;
 * the reducer appends the new addendum to submission.addenda. Used by
 * non-authors who can't edit but can append.
 */
export function addAddendumPatientAction(uuidInvestigation, uuidPatient, surveyUUID, surveyName, idSubmission, body) {
    return async (dispatch) => {
        dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });

        return addAddendumToSubmissionService(uuidInvestigation, idSubmission, body)
            .then((response) => {
                dispatch({
                    type: types.ADD_ADDENDUM_TO_SUBMISSION_SUCCESS,
                    addendum: response.addendum,
                    meta: { uuidPatient, surveyUUID, surveyName, idSubmission }
                });
                return response;
            })
            .catch((error) => {
                const errorCode = error.response?.data?.errorCode || error.errorCode;
                const errorMessage = error.response?.data?.errorMessage || error.message;
                dispatch({
                    type: types.SAVE_SUBMISSIONS_PATIENT_ERROR,
                    error: errorCode,
                    errorMessage: errorMessage
                });
                const enhancedError = new Error(errorMessage || 'Failed to add addendum');
                enhancedError.errorCode = errorCode;
                enhancedError.originalError = error;
                throw enhancedError;
            });
    };
}


export function stopTreatmentPatientAction(postObj, uuidInvestigation, uuidPatient, surveyUUID, surveyName, idSubmission) {
  return async (dispatch) => {
    dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });

    return stopTreatmentPatientService(postObj, uuidInvestigation, uuidPatient, surveyUUID, idSubmission)
      .then((response) => {
        dispatch({
          type: types.STOP_TREATMENT_SUBMISSIONS_PATIENT_SUCCESS,
          submission: response.submission,
          meta:{uuidPatient, surveyUUID, surveyName, idSubmission}
        });
      })
      .catch((error) => {
        
        if(!error.status && !error.response){
          const offlinePost = postObj;
          //offlinePost.surveyRecords = postObj.submission[0].answers;
          dispatch({
            type: types.STOP_TREATMENT_SUBMISSIONS_PATIENT_OFFLINE,
            submission: offlinePost,
            meta:{uuidPatient, surveyUUID, surveyName, idSubmission}
                });
          }
          else{
            // SHER-572: a failed stop is not a failed save of the page. The generic
            // SAVE_SUBMISSIONS_PATIENT_ERROR set a truthy `error` that patient/index.jsx
            // turns into a collapsed patient view outside a fill/update flow — where the
            // patient-file annul runs. Reset loading without the fatal flag and re-throw:
            // both callers (SubmissionsTable's reason modal, FillSurvey's inpatient stop)
            // show the reason themselves.
            dispatch({ type: types.STOP_TREATMENT_SUBMISSIONS_PATIENT_ERROR });
            throw error;
          }
       
      });
  };
}




export function resendOfflineRecords(offlineRecords, uuidInvestigation){
    return async (dispatch) => {
        let hasSentRecords = false;
        Object.keys(offlineRecords.data).forEach((uuidPatient) => {
            const surveysOffline = offlineRecords.data[uuidPatient]
            Object.keys(surveysOffline).forEach((uuidSurvey) => {
                const records = surveysOffline[uuidSurvey]; 
                records.submissions.forEach(async(submission) => { 
                    if(submission.offline){
                        await dispatch( postSubmissionPatientAction(submission, uuidInvestigation, uuidPatient, uuidSurvey, records.surveyName, records.type, submission.id));
                        dispatch({ type: types.RESET_OFFLINE_NOTIFICATIONS});
                    }
                })
                
            })
        })
        if(hasSentRecords){
            
        }
    }
}

export function resetPatientsSubmissionsError() {
  return async (dispatch) => {
    dispatch({ type: types.SUBMISSIONS_PATIENT_RESET_ERROR});

  };
}


export function deleteSubmissionPatientAction(postObj, uuidInvestigation, idSubmission, uuidPatient, uuidSurvey) {
  return async (dispatch) => {
      dispatch({ type: types.SUBMISSIONS_PATIENT_LOADING });                //Loading state in redux, it disables buttons, actions, etc

      return deleteSubmission(postObj, uuidInvestigation, idSubmission)
          .then((response) => {
              dispatch({                                                    //Remove submission from redux state after API call is succeeds
                  type: types.REMOVE_SUBMISSIONS_PATIENT,
                  meta: {
                      uuidPatient: uuidPatient,
                      idSubmission,
                      uuidSurvey
                  }
              });
          })
          .catch((error) => {
              if (!error.status && !error.response) {                         //If offline or network is not available
                  dispatch({
                      type: types.REMOVE_SUBMISSIONS_PATIENT,
                      meta: {
                          uuidPatient: uuidPatient,
                          idSubmission,
                          uuidSurvey
                      }
                  });
              } 
              
              else if (error?.status === 401 || error?.response?.status === 401) {
                dispatch({ type: types.PERMISSION_SUBMISSIONS_PATIENT_ERROR });
              }

              else {
                // SHER-537: a failed DELETE is not a failed FETCH. Emitting the
                // generic FETCH error sets patientsSubmissions.error=true, which
                // patient/index.jsx turns into setError(true) and blanks the whole
                // workspace view (the reported crash). Reset loading via a
                // delete-specific error that does NOT flip the view into its fatal
                // state, and re-throw so the calling component renders an inline
                // message (e.g. the API's 24h-immutability reason) instead.
                dispatch({ type: types.DELETE_SUBMISSIONS_PATIENT_ERROR });
                throw error;
              }
          });
  };
}